const NAME = 'VIDEO';

export const getVideo = (store) => store[NAME].info;
export const getVideos = (store) => store[NAME].list.data;
export const videosPageMeta = (store) => store[NAME].list.page;
export const getVideosCacheExp = (store) => store[NAME].list.exp;
export const getVideoCategories = (store) => store[NAME].categories.data;
export const videoCategoriesCacheExpired = (store) =>
  new Date().getTime() > store[NAME].categories.exp;
